var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: "logonamn"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-and-name",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 600",
    style: {
      enableBackground: "new 0 0 425.197 283.465"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2_00000088107567393558822800000016501632484635238320_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "initials",
    id: "Lager_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "firstletter",
    d: "M75.321,73.065H46.587v79.429h-21.98V73.065H5.464v-17.85h69.857V73.065z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "firstletter",
    d: "M54,175.7V78.4h20.4c10.8,0,19.2,2,25.1,6c5.7,3.7,9,10.1,8.8,16.8c0.1,5.1-1.9,10.1-5.4,13.9 c-3.7,4-8.4,6.8-13.6,8.1v0.3c6.3,0.6,12.1,3.3,16.6,7.7c4.1,4.1,6.3,9.7,6.2,15.4c0.3,8.2-3.3,16.1-9.6,21.2 c-6.4,5.2-15.1,7.8-26.1,7.8L54,175.7z M75.9,94.6v23.2l0,0c2.9-1.3,2.2-0.9,5.2-3.3c2.6-2.3,4-5.6,3.9-9.1 C85,98.3,82.4,96.8,75.9,94.6L75.9,94.6z M75.9,133.9v25.6l0,0c5-0.8,5.8-1.2,8.7-3.5c2.9-2.4,4.5-5.9,4.3-9.6 c0.1-3.6-1.4-7-4.2-9.2C81.9,135,81,134.6,75.9,133.9L75.9,133.9L75.9,133.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "firstname"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M123.639,109.25V66.913h-15.465V54.624h41.746v12.289h-10.565v42.337H123.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M175.981,110.06c-5.297,0-9.488-0.72-12.573-2.158c-3.086-1.438-5.297-3.507-6.635-6.205 c-1.34-2.698-2.008-5.912-2.008-9.644V71.754c0-3.777,0.668-6.991,2.008-9.644c1.338-2.652,3.549-4.687,6.635-6.103 c3.084-1.417,7.275-2.125,12.573-2.125c5.355,0,9.589,0.708,12.704,2.125c3.113,1.416,5.339,3.451,6.679,6.103 c1.338,2.653,2.008,5.867,2.008,9.644v20.299c0,3.732-0.669,6.946-2.008,9.644c-1.34,2.698-3.566,4.766-6.679,6.205 C185.571,109.34,181.336,110.06,175.981,110.06z M175.981,101.495c1.629,0,2.823-0.314,3.58-0.944 c0.755-0.629,1.251-1.438,1.484-2.428c0.232-0.989,0.35-2,0.35-3.035V68.787c0-1.079-0.118-2.102-0.35-3.069 c-0.233-0.966-0.729-1.764-1.484-2.394c-0.757-0.629-1.951-0.944-3.58-0.944c-1.514,0-2.649,0.315-3.405,0.944 c-0.757,0.63-1.252,1.428-1.484,2.394c-0.233,0.967-0.349,1.99-0.349,3.069v26.301c0,1.035,0.101,2.046,0.305,3.035 c0.204,0.989,0.668,1.799,1.397,2.428C173.173,101.181,174.352,101.495,175.981,101.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M214.303,109.25l-12.748-54.626h13.358l7.596,37.092l7.072-37.092h14.145l-12.922,54.626H214.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M249.836,109.25V54.624h31.781v8.228h-16.152v13.556h12.311v8.362h-12.311v16.321h16.327v8.16H249.836z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.006,
    y: 33.047,
    style: {
      fill: "none"
    },
    width: 123.077,
    height: 10.059
  }), /*#__PURE__*/React.createElement("g", {
    className: "lastname"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M130.285,172.896v-53.065h13.499c2.217,0,4.319,0.175,6.302,0.524c1.983,0.35,3.743,1.015,5.278,1.998 c1.536,0.982,2.74,2.381,3.615,4.193c0.874,1.812,1.312,4.204,1.312,7.173c0,2.141-0.31,3.942-0.927,5.405 c-0.619,1.464-1.494,2.632-2.624,3.505c-1.13,0.874-2.485,1.464-4.062,1.769c2.004,0.263,3.689,0.929,5.054,1.998 c1.365,1.071,2.399,2.501,3.103,4.291c0.704,1.792,1.056,3.954,1.056,6.486c0,2.751-0.352,5.121-1.056,7.107 c-0.704,1.988-1.717,3.615-3.039,4.881c-1.322,1.268-2.954,2.206-4.894,2.817c-1.941,0.612-4.17,0.917-6.686,0.917H130.285z  M141.737,141.058h2.239c1.749,0,3.071-0.272,3.967-0.819c0.896-0.545,1.503-1.343,1.823-2.391c0.32-1.048,0.48-2.314,0.48-3.8 c0-1.397-0.246-2.565-0.736-3.505c-0.491-0.938-1.215-1.648-2.175-2.129c-0.959-0.48-2.165-0.72-3.615-0.72h-1.983V141.058z  M141.737,164.707h2.431c2.516,0,4.254-0.654,5.214-1.965c0.96-1.311,1.439-3.231,1.439-5.766c0-2.008-0.214-3.603-0.64-4.782 c-0.427-1.179-1.13-2.041-2.111-2.587c-0.981-0.546-2.303-0.819-3.966-0.819h-2.367V164.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M166.938,172.896v-53.065h14.267c3.497,0,6.525,0.393,9.085,1.179c2.559,0.786,4.552,2.195,5.982,4.226 c1.428,2.031,2.143,4.903,2.143,8.615c0,2.185-0.171,4.127-0.512,5.831c-0.342,1.704-0.971,3.178-1.887,4.422 c-0.918,1.245-2.229,2.283-3.935,3.112l7.102,25.681h-11.836l-5.694-23.781h-3.263v23.781H166.938z M178.39,142.368h3.199 c1.621,0,2.879-0.294,3.774-0.884c0.896-0.589,1.525-1.441,1.888-2.555c0.362-1.114,0.544-2.457,0.544-4.029 c0-2.271-0.406-4.039-1.216-5.307c-0.811-1.266-2.303-1.899-4.479-1.899h-3.71V142.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M203.149,172.896l9.789-53.065h13.051l9.661,53.065h-10.557l-1.728-11.202h-7.613l-1.791,11.202H203.149z M216.775,154.685 h5.503l-2.751-20.702L216.775,154.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M240.384,172.896v-53.065h8.062l10.62,25.55v-25.55h9.469v53.065h-7.741l-10.621-27.515v27.515H240.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M274.656,172.896v-53.065h13.115c4.521,0,8.039,0.58,10.557,1.736c2.516,1.158,4.286,2.97,5.31,5.438 c1.024,2.468,1.536,5.667,1.536,9.598v19.26c0,3.975-0.512,7.218-1.536,9.729c-1.023,2.512-2.782,4.356-5.277,5.536 c-2.495,1.179-5.982,1.769-10.461,1.769H274.656z M286.108,164.773h1.791c1.749,0,3.007-0.263,3.774-0.786 c0.769-0.524,1.248-1.311,1.44-2.359c0.191-1.048,0.287-2.358,0.287-3.931v-23.125c0-1.572-0.117-2.838-0.352-3.8 c-0.235-0.96-0.735-1.659-1.504-2.096c-0.768-0.436-2.005-0.655-3.71-0.655h-1.728V164.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M316.689,172.896v-44.352h-7.805v-8.713h27.062v8.713h-7.741v44.352H316.689z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logoName.920d12a34fde9686c806a12e50845a55.svg";
export { ForwardRef as ReactComponent };